import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { canDisplayImage } from '@gift-variable-plugins/photo-shared/canDisplayImage';
import { PhotoVariableInput } from '@gift-variable-plugins/photo-shared/PhotoVariableInput';
import { editInput } from './editInput';

export const mergePhotoIntoPrefab = (
    prefabInput: GiftJson.Input<PhotoVariableInput>,
    userInput: GiftJson.Input<PhotoVariableInput>
): GiftJson.Input<any> => {

    const fromUser = userInput.value;

    if (canDisplayImage(fromUser)) {

        return editInput(prefabInput, {

            processed: fromUser.processed,
            status: fromUser.status,
            cropBox: fromUser.cropBox,
            fileName: fromUser.fileName,

            assetId: fromUser.assetId,
            assetSource: fromUser.assetSource,
            localUrl: fromUser.localUrl,

            imageWidth: fromUser.imageWidth,
            imageHeight: fromUser.imageHeight,
            filter: fromUser.filter
        });
    }

    return prefabInput;
};